<template>
  <div id="address-data-form">
    <header class="panel__header mt-2">
      <h2 class="panel__title">{{ $t('SEU ENDEREÇO') }}:</h2>
    </header>

    <div id="form-dados-endereco" class="row mt-4">
      <div class="col-12 col-sm-12">
        <div class="panel__content">
          <div class="row">
            <p class="col-12 col-sm-4">
              <masked-input
                v-validate="'required|not_prefix:' + plano.postal_code_prefix"
                type="text"
                name="cep"
                class="form-control"
                :class="{ 'is-invalid': errors.has('cep') }"
                v-model="user.cep"
                :mask="[/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]"
                v-on:keydown.delete="onDeleteMask"
                :guide="false"
                :placeholder="$t('CEP') + ':'"
                v-on:keyup="searchPostalCode"
              >
              </masked-input>

              <span class="invalid-feedback">
                {{ errors.first("cep") }}
              </span>
            </p>
            <p
              class="col-12 col-sm-8"
              style="
                display: flex;
                flex-direction: column;
                justify-content: center;
              "
            >
              <a
                href="http://www.buscacep.correios.com.br/sistemas/buscacep/"
                target="_blank"
                >{{ $t('Não sei o meu CEP') }}</a
              >
            </p>
          </div>

          <div class="row">
            <p class="col-12 col-sm-8">
              <input
                :class="{ input: true, 'is-invalid': errors.has('endereco') }"
                name="endereco"
                v-validate="'required'"
                type="text"
                class="form-control"
                v-model="user.endereco"
                id="endereco"
                :placeholder="$t('Endereço') + ':'"
                value=""
              />
              <span class="invalid-feedback">
                {{ errors.first("endereco") }}
              </span>
            </p>
            <p class="col-12 col-sm-4">
              <input
                :class="{ input: true, 'is-invalid': errors.has('bairro') }"
                name="bairro"
                v-validate="'required'"
                type="text"
                class="form-control"
                v-model="user.bairro"
                id="bairro"
                :placeholder="$t('Bairro') + ':'"
                value=""
              />
              <span class="invalid-feedback">
                {{ errors.first("bairro") }}
              </span>
            </p>
          </div>

          <div class="row">
            <p class="col-12 col-sm-4">
              <input
                :class="{ input: true, 'is-invalid': errors.has('numero') }"
                name="numero"
                v-validate="'required'"
                type="text"
                class="form-control"
                v-model="user.numero"
                id="numero"
                :placeholder="$t('Número') + ':'"
                value=""
                maxlength="5"
              />
              <span class="invalid-feedback">
                {{ errors.first("numero") }}
              </span>
            </p>
            <p class="col-12 col-sm-8">
              <input
                :class="{
                  input: true,
                  'is-invalid': errors.has('complemento'),
                }"
                name="complemento"
                type="text"
                class="form-control"
                v-model="user.complemento"
                id="complemento"
                :placeholder="$t('Complemento') + ':'"
                value=""
                maxlength="30"
              />
              <span class="invalid-feedback">
                {{ errors.first("complemento") }}
              </span>
            </p>
          </div>

          <div class="row">
            <p class="col-12 col-sm-6">
              <select
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('estado') }"
                name="estado"
                class="form-control"
                v-model="user.estado"
                id="estado"
              >
                <option selected="" value="" disabled>{{ $t('Estado') }}</option>
                <option value="AC">Acre</option>
                <option value="AL">Alagoas</option>
                <option value="AP">Amapá</option>
                <option value="AM">Amazonas</option>
                <option value="BA">Bahia</option>
                <option value="CE">Ceará</option>
                <option value="DF">Distrito Federal</option>
                <option value="ES">Espírito Santo</option>
                <option value="GO">Goiás</option>
                <option value="MA">Maranhão</option>
                <option value="MT">Mato Grosso</option>
                <option value="MS">Mato Grosso do Sul</option>
                <option value="MG">Minas Gerais</option>
                <option value="PA">Pará</option>
                <option value="PB">Paraíba</option>
                <option value="PR">Paraná</option>
                <option value="PE">Pernambuco</option>
                <option value="PI">Piauí</option>
                <option value="RJ">Rio de Janeiro</option>
                <option value="RN">Rio Grande do Norte</option>
                <option value="RS">Rio Grande do Sul</option>
                <option value="RO">Rondônia</option>
                <option value="RR">Roraima</option>
                <option value="SC">Santa Catarina</option>
                <option value="SP">São Paulo</option>
                <option value="SE">Sergipe</option>
                <option value="TO">Tocantins</option>
              </select>
              <span class="invalid-feedback">
                {{ errors.first("estado") }}
              </span>
            </p>
            <p class="col-12 col-sm-6">
              <select
                v-validate="'required'"
                :class="{ 'is-invalid': errors.has('cidade') }"
                name="cidade"
                class="form-select"
                v-model="user.cidade"
                id="cidade"
                readonly
              >
                <option value="">{{ $t('Cidade') }}...</option>
                <option 
                  v-for="city in cities" 
                  :key="city.nome"
                  :value="city.nome"
                >
                  {{ city.nome }}
                </option>
              </select>
              <span class="invalid-feedback">
                {{ errors.first("cidade") }}
              </span>
            </p>
          </div>

          <div
            class="row"
            v-if="
              plano.apenas_carteirinha_digital != 'sim' &&
              (
                plano.entrega_clube != 'N' ||
                plano.entrega_comercial != 'N' ||
                plano.entrega_residencia != 'N'
              ) && 
              
              ((user.kit != null && user.kit.card !== 0) || user.kit === null)
            "
          >
            <div class="col-12">
              <div class="row">
                <div class="col-12 col-sm-5">{{ $t('Entrega do Kit') }}:</div>
                <div class="col-12 col-sm-7">
                  <span class="ps-md-5 pe-md-4 ps-md-2 pe-md-2" v-if="plano.entrega_clube != 'N'">
                    <input
                      type="radio"
                      :class="{ 'is-invalid': errors.has('temKit') }"
                      v-model="user.temkit"
                      name="temKit"
                      id="temkit1"
                      class="form-check-input"
                      v-validate="'required'"
                      value="Clube"
                    />
                    <label for="temkit1">{{ $t('No Clube') }}</label>
                  </span>
                  <span class="ps-md-4 pe-md-4 ps-md-2 pe-md-2" v-if="plano.entrega_residencia != 'N'">
                    <input
                      type="radio"
                      :class="{ 'is-invalid': errors.has('temKit') }"
                      v-model="user.temkit"
                      name="temKit"
                      id="temkit2"
                      class="form-check-input"
                      v-validate="'required'"
                      value="Residencia"
                    />
                    <label for="temkit2">{{ $t('No endereço cadastrado') }}</label>
                    <span class="invalid-feedback ps-5 mt-0">
                      {{ $t('Selecione uma opção') }}
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="row" v-if="dependentes.length > 0">
            <div class="col-12" v-if="config.temDepPlus == 0">
              <div>
                <div class="row">
                  <div class="col-12 col-sm-5">
                    {{ $t('Deseja adicionar dependentes em seu cadastro?') }}
                  </div>
                  <div class="col-12 col-sm-7">
                    <span class="ps-5 pe-4">
                      <input
                        data-vv-as="dependentes"
                        type="radio"
                        :class="{ 'is-invalid': errors.has('temDependentes') }"
                        v-model="user.temDependentes"
                        name="temDependentes"
                        id="temDependentes1"
                        class="form-check-input"
                        v-validate="'required|included:S,N'"
                        value="S"
                      />
                      <label for="temDependentes1">{{ $t('Sim') }}</label>
                    </span>

                    <span class="ps-4 pe-4">
                      <input
                        data-vv-as="dependentes"
                        type="radio"
                        :class="{ 'is-invalid': errors.has('temDependentes') }"
                        v-model="user.temDependentes"
                        name="temDependentes"
                        id="temDependentes2"
                        class="form-check-input"
                        value="N"
                      />
                      <label for="temDependentes2">{{ $t('Não') }}</label>
                      <span class="invalid-feedback ps-5">
                        {{ errors.first("temDependentes") }}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12" v-else>
              <input
                data-vv-as="dependentes"
                type="radio"
                v-model="user.temDependentes"
                name="temDependentes"
                id="temDependentes1"
                class="form-check-input"
                value="S"
                style="display: none"
                checked="checked"
              />
            </div>
          </div>
          <div class="row" v-else>
            <input
              type="hidden"
              data-vv-as="dependentes"
              v-model="user.temDependentes"
              name="temDependentes"
              value="N"
            />
          </div>
          <div class="row">
            <div class="col-12">
              <b-alert
                variant="danger"
                dismissible
                :show="error.show"
                v-model="error.show"
              >
                <div>{{ error.text }}</div>
              </b-alert>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      fields: [
        "cep",
        "endereco",
        "bairro",
        "numero",
        "estado",
        "cidade",
        "temKit",
        "temDependentes",
      ],
      error: {
        show: false,
        text: '',
      },
      cities: [],
      selected_city: ""
    }
  },
  props: {
    user: {
      required: true,
      type: Object
    },
    config: {
      required: true,
      type: Object
    },
    plano: {
      required: true,
      type: Object
    },
    dependentes: {
      required: true,
      type: Array
    },
  },
  methods: {
    async submit() {
      try {
        if (!await this.$validator.validateAll(this.fields)) {
          throw new Error('Preencha os campos corretamente');
        }
        
        document.querySelectorAll("input").forEach(
          (input) => {
            if (input.name.match(/(dataNascimento)\_\d\_\d+/g)) {
              VMasker(input).maskPattern("99/99/9999")
            }
          }
        )

        return await this.updateUser()
      } catch (error) {
        $("html, body").animate(
          { scrollTop: $("#cadastroSocio").offset().top - 10 },
          500,
          "swing"
        )

        return false
      }
    },
    async updateUser() {
      try {
        const response = await axios.put(
          `/cadastro/dados-pessoais/${this.user.id}/end`,
          {
            userId: this.user.id,
            ...this.user,
          }
        )
  
        if (response.data.login) {
          window.location.href = "/login"
        }
        
        this.dependentes.forEach(
          (plano) => {
            if (plano.plus == "Y") {
              plano.dependentes.forEach(
                (dependente) => {
                  if (this.user.nome) {
                    dependente.nomeCompleto = this.user.nome + " " + this.user.sobrenome
                  }
                }
              )
            }
          }
        )

        return true
      } catch (error) {
        this.error.show = true
        
        if (typeof error.response.data.errors.email[0] !== 'undefined') {
          this.error.message = error.response.data.errors.email[0]
        } else {
          this.error.message = "Erro interno, tente novamente mais tarde."
        }

        return false
      }
    },
    removeAccents(text) {
      return text
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
    },
    async searchPostalCode() {
      const cep = this.user.cep;

      if(cep.length != 9) {
        return
      }
      
      try {
        const response = await axios.get(`/api/zip/BR/${cep}`)
  
        this.user.endereco = response.data.data.logradouro
        this.user.complemento = ''
        this.user.bairro = response.data.data.bairro
        this.user.estado = response.data.data.uf
        this.user.cidade = response.data.data.localidade
        this.getMunicipalities()

      } catch (error) {
        console.log(error)        
      }
    },
    async getMunicipalities() {
      try {
        const response = await axios.get('/api/cidades/' + this.user.estado)

        if(response.data) {
          this.cities = response.data.data
          this.selected_city = this.removeAccents(this.user.cidade)
        }
      } catch (error) {
        console.log(error)
      }
    },
    // Não faço a menor ideia do que isso faz, originalmente foi escrito pelo David Petter.
    onDeleteMask(event) {
      let value = event.target.value; 
      let char = value[value.length-1];
      if (isNaN(parseInt(char)) || char == ' ') { event.target.value = value.substring(0, value.length-1); }
    }
  },
});
</script>
